import script from "./TasksList.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksList.vue?vue&type=script&setup=true&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=32c270d0&lang=scss"

const __exports__ = script;

export default __exports__